import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { hasPermission } from "../../core/utils/permissionHelper";

const labelToModule = {
  "Patients": "Patients",
  "Procedures": "Procedures",
  "Doctors": "Doctors",
  "Products": "Products",
  "Suppliers": "Suppliers",
  "Account Heads": "Account Heads",
  "Appointment Calendar": "Appointments",
  "Appointment List": "Appointments",
  "Invoices": "Invoices",
  "New Invoice": "Invoices",
  "Bill wise Receipt": "Invoices",
  "Medicine Bills": "Invoices",
  "New Medicine Bill": "Invoices",
  "Purchase List": "Purchases",
  "Purchase Return": "Purchases",
  "Opening Stock": "Stock",
  "Current Stock": "Stock",
  "Stock Adjustment": "Stock",
  "Expenses": "Expenses",
  "Additional Income": "Income",
  "Journal Entry": "Journal",
  "Supplier Advance": "Supplier Advances",
  "Supplier Payments": "Supplier Payments",
  "Appointment Report": "Reports",
  "Sales Report": "Reports",
  "Purchase Report": "Reports",
  "Expense Report": "Reports",
  "Stock Report": "Reports",
  "Stock Movement": "Reports",
  "Customer Statement": "Reports",
  "Supplier Statement": "Reports",
  "Receivables": "Reports",
  "Payables": "Reports",
  "MIS Report": "Reports",
  "Daily Report": "Reports",
  "Payment Report": "Reports",
  "Patient History": "Reports",
  "Users": "Users",
  "Roles & Permissions": "Users",
  "Audit Log": "Audit Log",
};

const Sidebar = () => {

  const Location = useLocation();


  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  // Collapsed (icon-only) sidebar: hovering a section shows its title and page names in a
  // flyout beside the rail. It's portalled to <body> because .sidebar clips its overflow.
  const [flyout, setFlyout] = useState(null); // { label, items, top, left }
  const hideTimer = useRef(null);
  const isCollapsed = () =>
    window.innerWidth > 991 &&
    document.body.classList.contains("mini-sidebar") &&
    !document.body.classList.contains("expand-menu");
  const cancelHide = () => clearTimeout(hideTimer.current);
  // Short delay so the pointer can cross the gap from the rail into the flyout.
  const scheduleHide = () => {
    cancelHide();
    hideTimer.current = setTimeout(() => setFlyout(null), 150);
  };
  const showFlyout = (e, label, items) => {
    if (!isCollapsed()) return;
    cancelHide();
    const rect = e.currentTarget.getBoundingClientRect();
    const sidebarRight = document.getElementById("sidebar")?.getBoundingClientRect().right ?? rect.right;
    // Keep a tall section on screen instead of letting it run off the bottom.
    const estHeight = 56 + items.length * 44;
    const top = Math.max(8, Math.min(rect.top, window.innerHeight - estHeight - 8));
    setFlyout({ label, items, top, left: sidebarRight + 4 });
  };

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {SidebarData?.map((mainLabel, index) => {
                  const visibleItems = mainLabel?.submenuItems?.filter(item => {
                    if (item.label === "Dashboard" || item.label === "Logout") return true;
                    const mod = labelToModule[item.label];
                    return mod ? hasPermission(mod, "View") : true;
                  }) || [];

                  if (visibleItems.length === 0) return null;

                  return (
                    <li
                      className="submenu-open"
                      key={index}
                      onMouseEnter={(e) => showFlyout(e, mainLabel?.label, visibleItems)}
                      onMouseLeave={scheduleHide}
                    >
                      <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                      <ul>
                        {visibleItems.map((title, i) => {
                          let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <React.Fragment key={i}>
                            {" "}
                            <li
                              className={`submenu ${
                                !title?.submenu &&
                                Location.pathname === title?.link
                                  ? "custom-active-hassubroute-false"
                                  : ""
                              }`}
                            >
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }`}
                              >
                                {title?.icon}
                                <span className="custom-active-span">
                                  {title?.label}
                                </span>
                                {title?.submenu && (
                                  <span className="menu-arrow" />
                                )}
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      <Link
                                        to={item?.link}
                                        className={`${
                                          item?.submenuItems
                                            ?.map((link) => link.link)
                                            .includes(Location.pathname) ||
                                          item?.link === Location.pathname
                                            ? "active"
                                            : ""
                                        } ${
                                          subsidebar === item?.label
                                            ? "subdrop"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          toggleSubsidebar(item?.label)
                                        }
                                      >
                                        {item?.label}
                                        {item?.submenu && (
                                          <span className="menu-arrow inside-submenu" />
                                        )}
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar === item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, subIndex) => (
                                            <li key={subIndex}>
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ===
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </ul>
                  </li>
                );
              })}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      {flyout && createPortal(
        <div
          className="sidebar-flyout"
          style={{ top: flyout.top, left: flyout.left }}
          onMouseEnter={cancelHide}
          onMouseLeave={scheduleHide}
        >
          <div className="sidebar-flyout-hdr">{flyout.label}</div>
          <ul>
            {flyout.items.map((item, i) => (
              <li key={i}>
                <Link
                  to={item?.link}
                  className={Location.pathname === item?.link ? "active" : ""}
                  onClick={() => setFlyout(null)}
                >
                  {item?.icon}
                  <span>{item?.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>,
        document.body
      )}
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
